import { Person, SettingsSuggest, Verified } from '@mui/icons-material';
import { Icon, Tooltip } from '@mui/material';
import { getUser } from 'lib/firebase';
import { useEffect, useState } from 'react';
import { FirebaseUser } from 'types/User/firebaseTypes';
import { Ticket } from 'types/User/firebaseTypes/ticket';
import styles from './CreatedBy.module.scss';

export interface CreatedByProps {
    ticket: Ticket;
    showIcon?: boolean;
    showText?: boolean;
}

export const CreatedBy = ({
    ticket,
    showIcon = true,
    showText = true,
}: CreatedByProps) => {
    const [createdByDisplayText, setCreatedByDisplayText] = useState('N/A');
    const [iconElem, setIconElem] = useState<JSX.Element>(<div />);

    useEffect(() => {
        if (ticket) {
            if (ticket.createdBy === 'Auto') {
                setCreatedByDisplayText('Auto');
                setIconElem(
                    <SettingsSuggest data-testid="SettingsSuggestIcon" />
                );
            } else if (
                ticket.createdBy === 'Confirmed Auto' ||
                ticket.createdBy === 'Auto Confirmed'
            ) {
                setCreatedByDisplayText('Confirmed Auto');
                setIconElem(<Verified data-testid="VerifiedIcon" />);
            } else {
                getUser(ticket.createdBy).then((user: FirebaseUser | null) => {
                    if (user) setCreatedByDisplayText(user?.info?.email);
                    setIconElem(<Person data-testid="PersonIcon" />);
                });
            }
        }
    }, [ticket]);

    return (
        <div data-testid="CreatedBy" className={styles.createdBy}>
            {showIcon && (
                <Tooltip title={createdByDisplayText}>
                    <Icon>{iconElem}</Icon>
                </Tooltip>
            )}
            {showText && <span>{createdByDisplayText}</span>}
        </div>
    );
};
